import { propPanelMixin } from '../../../helpers';
import EventCardList from "./EventCardList/index";
import ReportCardList from "./ReportCardList/index";
import PluginCardList from "./PluginCardList/index";
const __script_base__ = {
  name: 'EventPanel',
  mixins: [propPanelMixin],
  components: {
    EventCardList,
    ReportCardList,
    PluginCardList
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-eventPanel"
  }, [_c("EventCardList", {
    attrs: {
      "comp-path": _vm.compPath
    }
  }), _vm._v(" "), _c("ReportCardList", {
    attrs: {
      "comp-path": _vm.compPath
    }
  }), _vm._v(" "), _c("PluginCardList", {
    attrs: {
      "comp-path": _vm.compPath
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/EventPanel/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);